const REGISTRATION_TYPE = Object.freeze({
  SOLO: 1,
  FAMILY_PLAN: 2,
  MULTI_PHONE: 3
})

export default REGISTRATION_TYPE



// WEBPACK FOOTER //
// ./src/constants/registration/registrationType.js